function showRecoverPasswordForm() {
    $('#RecoverPasswordForm').removeClass('d-none');
    $('#CustomerLoginForm').addClass('d-none');
}

function hideRecoverPasswordForm() {
    $('#RecoverPasswordForm').addClass('d-none');
    $('#CustomerLoginForm').removeClass('d-none');
}

jQuery(document).ready(function($){

    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
        evt.preventDefault();
        showRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
        evt.preventDefault();
        hideRecoverPasswordForm();
    });

    $('.address-edit-toggle').on('click', function(evt) {
        var formId = $(this).data('form-id');
        var $editAddress = $('#EditAddress_' + formId);

        evt.preventDefault();
        $editAddress.toggleClass('d-none');
    });

    $('.address-delete').on('click', function() {
        var $el = $(this);
        var target = $el.data('target');
        var confirmMessage = $el.data('confirm-message');
  
        // eslint-disable-next-line no-alert
        if (
            confirm(
                confirmMessage || 'Are you sure you wish to delete this address?'
            )
        ) {
            Shopify.postLink(target, {
                parameters: { _method: 'delete' }
            });
        }
    });

    $("#back-to-menu").on('click', function(){
        $(".mega-menu-shop").removeClass("is-open");
    });

    $("#ResetSuccess").fadeTo(2000, 500).slideUp(500, function(){
        $("#ResetSuccess").slideUp(500);
    });

    $(".meet-team-wrapper .members .wrap_object").on('click', function(){
        if($(window).width() < 768) {
            $(this).find('.wrap_desc').slideToggle('400');
        }
    });

    $(".member-slide-up").on('click', function(e){
        if($(window).width() < 768) {
            e.stopPropagation();
            $(this).closest('.wrap_desc').slideUp('400');
        }
    });

    $(".product-related-carousel").owlCarousel({
        items: 3,
        margin: 32,
        nav: false,
        dots: false,
        responsiveClass: true,
        responsive:{
            0:{
                items: 1,
                center: true,
                loop: true,
                 margin:32,
                autoplay: true,
                autoplayTimeout: 6000
            },
            576:{
                items: 3,
                center: false,
                loop: false
            }
        }
    });

    $("#opt-btn").on('click', function(event){
        var $form = $(this).closest('form');
        var $modalBody = $(this).closest(".modal-body");
        $modalBody.find('.scene-1').hide();
        $modalBody.find('.scene-2').show();
        $.ajax({
            type: 'POST',
            url: $form.attr("action"),
            data: $form.serialize(),
            beforeSend: function() {
                $form.addClass('sending');
            },
            error: function(t) {
                $form.addClass('sent');
                $form.find('.errorMsg').fadeIn();
            },
            success: function(response) {
                // $form.find('.scene-1').hide();
                // $form.find('.scene-2').show();
            }
        }); 
    });

    $("#newsletter_submit").on("click", function(event){
        var $form = $(this).closest('form');
        $.ajax({
            type: 'POST',
            url: $form.attr("action"),
            data: $form.serialize()
        }); 
    });

    $(".newsletter-form").submit(function(e){
        e.preventDefault();
        var $form = $(this);
        $.ajax({
            type: 'POST',
            url: $form.attr("action"),
            data: $form.serialize()
        }); 
    })
});